module.exports = __webpack_public_path__ + "img/newsImg6-9.a042b216.png";